exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-checkbox .custom-control-input:checked~.custom-control-label:before{background-color:#3fa535}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label:before{background-color:rgba(63,165,53,.63)}th.selected-program-name,th.specification-type{text-align:center}.table-sanction h4,h3,h5{font-weight:700;color:#424242}.table-hover tbody tr.hover-none:hover{background-color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8de39a6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/AgrotechnicalMechanism.vue
// module id = eCVF
// module chunks = 0